import { ApplicationConfig } from "@angular/core";
import { provideState } from "@ngrx/store";

import { provideEffects } from "@ngrx/effects";
import { GridCellTransformPipe } from "../shared/pipes/grid-cell-transform.pipe";
import { ShipmentCreateStore } from "./shipment-create/store/shipment-create.store";
import { StepFlightsStore } from "./shipment-create/store/step-2-flights.store";
import { StepRulesStore } from "./shipment-create/store/step-3-rules.store";
import * as shipmentsDetail from "./shipments-detail/store";
import { metaReducers } from "./shipments-detail/store/metareducers";
import { StepTrucksStore } from "@src/app/shipments/shipment-create/store/step-2-trucks.store";
import { ConveyanceStore } from "@src/app/shipments/shipment-create/store/conveyance.store";

export const shipmentsConfig: ApplicationConfig = {
  providers: [
    provideState('shipment', shipmentsDetail.reducers, { metaReducers }),
    provideEffects(shipmentsDetail.effects),
    GridCellTransformPipe,
    ShipmentCreateStore,
    StepFlightsStore,
    StepTrucksStore,
    StepRulesStore,
    ConveyanceStore,
  ]
}
